<script lang="ts">
  import ComboboxInput, { type ComboboxOption } from '$components/reusable/ComboboxInput.svelte';
  import { getPostEditor } from '$lib/stores/postEditorStore';
  import { ForumType, type ForumDataList, type Forum } from '$shared/lib';
  import AcceleratorLockIcon from './icons/AcceleratorLockIcon.svelte';
  import AdminWarningIcon from './icons/AdminShieldIcon.svelte';

  export let forums: ForumDataList = [];
  export let forumName: Forum | undefined = undefined;
  export let forumType: ForumType | undefined = undefined;

  let initialValue = '';
  let searchValue = '';
  let options: ComboboxOption[] = [];

  const { openState } = getPostEditor();

  function onChange(option: ComboboxOption | null) {
    if (!option) {
      forumName = undefined;
      forumType = undefined;
      return;
    }

    const forum = forums.find((forum) => forum.id === option.id);
    if (forum) {
      forumName = forum.name;
      forumType = forum.type;
    }
  }

  openState.subscribe((state) => {
    if (state === 'hidden') {
      searchValue = '';
    }
  });

  $: {
    const forum = forums.find((f) => f.name === forumName && f.type === forumType);
    if (forum) {
      initialValue = String(forum.id);
    } else {
      initialValue = '';
    }

    options = forums
      .sort((a, b) => {
        if (a.type === ForumType.PUBLIC) return -1;
        if (b.type === ForumType.PUBLIC) return 1;
        if (a.type === ForumType.ACCELERATOR) return -1;
        if (b.type === ForumType.ACCELERATOR) return 1;
        return 0;
      })
      .map((forum) => {
        const icon = (() => {
          switch (forum.type) {
            case ForumType.ACCELERATOR:
              return AcceleratorLockIcon;
            case ForumType.ADMIN:
              return AdminWarningIcon;
            default:
              return null;
          }
        })();
        return {
          icon: icon,
          label: forum.name,
          description: forum.description,
          id: forum.id,
        };
      });
  }
</script>

<ComboboxInput
  id="forum"
  name="forum"
  label="Forum"
  placeholder="Select a forum..."
  value={initialValue}
  bind:searchValue
  {onChange}
  {options}
  {...$$props}
/>
